{
  "loading": "Chargement...",
  "loadingMore": "Chargement supplémentaire..."
}
